"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSourceFile = exports.mergeAndRemoveDuplicates = exports.isDisabled = exports.hasError = exports.getButtonText = exports.getAllowedExtensions = exports.fileHasMaxFileCountError = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _helpers = require("../../../helpers");
var _constants = require("../../../constants");
var _utils = require("../../../utils");
var getAllowedExtensions = exports.getAllowedExtensions = function getAllowedExtensions() {
  var isHlsEnabled = (0, _helpers.shouldHaveFeature)('studio.hls');
  var videoExtensions;
  if (isHlsEnabled) {
    videoExtensions = [].concat((0, _toConsumableArray2["default"])(_constants.VIDEO_EXTS), (0, _toConsumableArray2["default"])(_constants.ADDITIONAL_VIDEO_EXTS));
  } else {
    videoExtensions = (0, _toConsumableArray2["default"])(_constants.VIDEO_EXTS);
  }
  return [].concat((0, _toConsumableArray2["default"])(videoExtensions), (0, _toConsumableArray2["default"])(_constants.SUPPORTED_NON_VIDEO_EXTS));
};
var validateSourceFile = exports.validateSourceFile = function validateSourceFile(file, fileCount) {
  var errors = [];
  var fileExt = (0, _utils.getFileExtension)(file.name);
  var isValidFileType = getAllowedExtensions().includes(fileExt);
  var isMaxFileCount = fileCount > _constants.SOURCE_MAX_UPLOAD_COUNT;
  if (isMaxFileCount) {
    errors.push("Exceeds maximum number of uploads (limit is ".concat(_constants.SOURCE_MAX_UPLOAD_COUNT, ")"));
  }
  if (!isValidFileType) {
    errors.push('File type not supported');
  }
  if (+file.size > _constants.SOURCE_MAX_FILE_SIZE) {
    errors.push("File exceeds size limitation of (".concat((0, _utils.formatBytes)(_constants.SOURCE_MAX_FILE_SIZE), ")"));
  }
  return errors;
};
var hasError = exports.hasError = function hasError() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return errors.length > 0;
};
var fileHasMaxFileCountError = exports.fileHasMaxFileCountError = function fileHasMaxFileCountError() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return hasError(errors) && errors.some(function (error) {
    return error.includes('Exceeds maximum number of');
  });
};
var getButtonText = exports.getButtonText = function getButtonText(isSubmitting) {
  var submitText = 'Upload';
  var isSubmittingText = 'Uploading...';
  return isSubmitting ? isSubmittingText : submitText;
};
var isDisabled = exports.isDisabled = function isDisabled(files) {
  if (files.length === 0) {
    return true;
  }
  return files.some(function (file) {
    return hasError(file === null || file === void 0 ? void 0 : file.errors);
  });
};
var mergeAndRemoveDuplicates = exports.mergeAndRemoveDuplicates = function mergeAndRemoveDuplicates(selectedFiles, filesInQueue) {
  var uniqueMap = new Map();
  var newArray = [].concat((0, _toConsumableArray2["default"])(filesInQueue), (0, _toConsumableArray2["default"])(selectedFiles));
  newArray.forEach(function (file) {
    if (!uniqueMap.has("".concat(file.name, "-").concat(file.size))) {
      uniqueMap.set("".concat(file.name, "-").concat(file.size), file);
    }
  });
  return Array.from(uniqueMap.values());
};